import styled from 'styled-components';

import { Row } from '@components/formStyles';

export const RoomCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
`;

export const Wrapper = styled.div`
  padding: 15px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    padding: 15px 0;
  }
`;

export const Title = styled.h3`
  width: 630px;
  white-space: normal;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
    width: 100%;
  }
`;

export const Description = styled.div``;

export const DistantRow = styled(Row)`
  justify-content: space-between;
`;

export const CenteredRow = styled(Row)`
  align-items: center;
`;

export const ImagesWrapper = styled(Row)`
  margin-top: 30px;
  cursor: pointer;
`;

export const LeftField = styled.div`
  height: auto;
  position: relative;
  min-width: 405px;
  max-height: 240px;
`;

export const RightField = styled.div<{
  isImageExist?: boolean;
}>`
  height: ${({ isImageExist }) => (isImageExist ? 'auto' : '240px')};
  margin-left: 20px;
  cursor: default;
  flex: 1;
  position: relative;
`;

export const SmallImagesWrapper = styled(Row)`
  width: 100%;
  height: auto;
`;

export const SmallImage = styled.div`
  width: 103px;
  height: 62px;
  margin-right: 28px;
  margin-bottom: 15px;
  *,
  :after,
  :before {
    border-radius: 8px;
  }
`;

export const MobileFeaturesWrapper = styled.div`
  display: flex;
  overflow-x: auto;

  ::-webkit-scrollbar {
    display: none;
  }

  ::-webkit-scrollbar-thumb {
    display: none;
  }
`;

export const RoomFeatures = styled.div`
  text-align: center;
  border-radius: 8px;
  border: solid 1px #dedede;
  background-color: white;
  display: inline;
  margin: 12px 10px 0 0;
  padding: 9px 10px 11px 12px;
`;

export const ShowMore = styled.button`
  width: 46px;
  margin: 12px 10px 0 0;
  padding: 9px 10px 11px 12px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.clearBlue};
  cursor: pointer;
`;

export const PopoverWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: column;
`;

export const ImageContainerMobile = styled.div`
  position: relative;
`;

export const AvailableDatesWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
`;
